export default "__VITE_ASSET__CSuJctJ___"